import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { ParagraphComponent } from '@atoms/paragraph/paragraph.component';
import { ModalMainContentComponent } from '@molecules/modal/modal-main-content/modal-main-content.component';
import { ModalHeaderComponent } from '@molecules/modal/modal-header/modal-header.component';
import { ModalMainComponent } from '@molecules/modal/modal-main/modal-main.component';
import { ModalTitleComponent } from '@molecules/modal/modal-title/modal-title.component';
import { FinancingCalculatorFormComponent } from '@organisms/financing-calculator/financing-calculator-form/financing-calculator-form.component';
import { GlobalsService } from '@services/globals.service';
import { OnlineFormService } from '@services/online-form.service';
import { CarPaymentOptions } from '@models/car.model';
import { FinancingCalculator } from '@models/financing-calculator.model';
import { GtmService } from '@services/gtm.service';
import { LanguageService } from '@services/language.service';
import { FinancingFormService } from '@services/financing-form.service';

@Component({
  selector: 'app-financing-calculator-modal',
  imports: [TranslateModule, ParagraphComponent, ModalMainContentComponent, ModalHeaderComponent, ModalMainComponent, ModalTitleComponent, FinancingCalculatorFormComponent],
  templateUrl: './financing-calculator-modal.component.html',
  styleUrl: './financing-calculator-modal.component.scss',
})
export class FinancingCalculatorModalComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);
  private location = inject(Location);
  private globalsService = inject(GlobalsService);
  private onlineFormService = inject(OnlineFormService);
  private gtmService = inject(GtmService);
  private languageService = inject(LanguageService);
  private financingFormService = inject(FinancingFormService);
  @Input() data?: { id: number; price: number; paymentOptions?: CarPaymentOptions[]; type: 'online' | 'financing' };
  public months?: number;
  public advance?: number;
  public loanType?: string;

  dataChanged(data: FinancingCalculator): void {
    if (this.data?.type === 'online') {
      this.onlineFormService.formData.update((formData) => {
        formData.installment = data.calculatedData;
        return formData;
      });
      this.onlineFormService.calculatedData.update(() => data.calculatedData);
    }
  }

  ngOnInit(): void {

    const dataLayer = {
      event: 'page_view',
      pageURL: '/' + this.languageService.language() + '/mam-zajem-o-financovani',
      pageType: 'Form-1',
      pageTitle: 'Kalkulačka',
      data: {
        splatka: this.financingFormService.product()?.monthlyPayment,
        akontace: this.financingFormService.carContractData()?.advance,
        kategorie_zakazniku: this.loanType,
        doba_splaceni: this.financingFormService.carContractData()?.numberOfMonths,
      },
    };
    this.gtmService.pushGtm(dataLayer);
    const hash = this.location.path(true).split('#')[1];
    const fragmentParams = this.globalsService.getFragmentParams(hash);
    this.months = Number(fragmentParams['months']);
    this.advance = Number(fragmentParams['advance']);
    this.loanType = fragmentParams['loan-type'] || '1';
    this.cd.detectChanges();
  }
}
